import { useRef } from 'react'

/**
 * The value a dialog is showing, held for as long as it is on screen.
 *
 * Answering a dialog clears the state it reads from while it is still animating out,
 * so it would empty and collapse on the way off.
 */
export const useValueWhileOpen = <T>(open: boolean, value: T): T => {
  const held = useRef(value)
  if (open) {
    held.current = value
  }
  return held.current
}
